<div (dragover)="preventDefaultDragOver( $event )" (drop)="preventDefaultDrop( $event )">
  <router-outlet></router-outlet>
  <p-toast></p-toast>


  <!-- Confirmation modal !-->
  <p-confirmDialog [closeOnEscape]="false"
                   [closable]="false"
                   [acceptLabel]="'COMMON.CONFIRM' | translate"
                   [rejectLabel]="'COMMON.CANCEL' | translate">
  </p-confirmDialog>
</div>
